import * as React from 'react';
import { IConfig } from '@cian/config/shared';

import { useOpenZhkCardUxfbEvent } from './hooks';
import { TReduxStore } from '../../types/redux';
import { setRegionCookies } from '../../utils/businessLogic/geo';

interface IAppEffectsProps {
  config: IConfig;
  reduxStore: TReduxStore;
}

export const AppEffects: React.FC<IAppEffectsProps> = ({ config, reduxStore }) => {
  useOpenZhkCardUxfbEvent(config);

  React.useEffect(() => {
    const { newbuilding } = reduxStore.getState();
    setRegionCookies(newbuilding.geo.regionId as number, newbuilding.geo.mainTownId);
  }, [reduxStore]);

  return null;
};
